// extracted by mini-css-extract-plugin
export default {"container":"modal_container__cJgsq","navigation":"modal_navigation__7oKWy","content":"modal_content__Epcf5"};